// extracted by mini-css-extract-plugin
export default {"no-access":"NoAccess_no-access__rOMaz","no-access__message":"NoAccess_no-access__message__5fEOh","no-access__buttons":"NoAccess_no-access__buttons__d4wbb"};